import { Action } from '@openfin/predux';

import { RootState } from '../State';

export class OpenFrame extends Action<RootState> {
  constructor(public readonly key: string, public readonly isStream: boolean) {
    super();
  }
}
